import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onValueChange", "value", "compressDocLink", "onChange"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { useRefCallback } from '@tencent/glue-react-use';
import { Success, Tip, CloseOne, Upload } from '@tencent/adp-icons-react';
import React, { useMemo, useState, useEffect } from 'react';
import { Button } from '../../../Button';
import { Popover } from '../../../Popover';
import { VideoPanel } from '../MaterialPanel/VideoPanel/VideoPanel';
import { VALIDATE_LIST } from './videoValidateList';
import { usePrefixCls } from '../../../../config/hooks/usePrefixCls';
import { classnames } from '../../../../utils';
import { TransferStatus, VideoUploadStatus, VideoValidateKey } from '../MaterialUpload/util/videoUploadRequest';
export var VideoUploadChangeStatus;
(function (VideoUploadChangeStatus) {
  VideoUploadChangeStatus["SUCCESS"] = "success";
  VideoUploadChangeStatus["FAIL"] = "fail";
  VideoUploadChangeStatus["REMOVE"] = "remove";
})(VideoUploadChangeStatus || (VideoUploadChangeStatus = {}));
var UploadVideoStatusTag = function UploadVideoStatusTag(props) {
  var success = props.success,
    _props$successText = props.successText,
    successText = _props$successText === void 0 ? '上传成功' : _props$successText,
    onRemove = props.onRemove;
  var removeHandler = useRefCallback(onRemove);
  var cls = usePrefixCls('material-library-single-video-upload-video-item-upload-finish');
  return React.createElement("div", {
    className: cls
  }, React.createElement("span", {
    className: "".concat(cls, "-info")
  }, success ? React.createElement(Success, {
    size: 16,
    fill: "#67C23A"
  }) : React.createElement(Tip, {
    size: 16,
    fill: "#FFA600"
  }), React.createElement("span", {
    className: "".concat(cls, "-info-text")
  }, success ? successText : '上传失败')), React.createElement(CloseOne, {
    className: "".concat(cls, "-remove"),
    size: 16,
    fill: "#868E9F",
    onClick: removeHandler
  }));
};
var VideoFailDetailItem = function VideoFailDetailItem(props) {
  var _props$validateKey = props.validateKey,
    validateKey = _props$validateKey === void 0 ? [] : _props$validateKey,
    failValueMap = props.failValueMap,
    value = props.value,
    className = props.className;
  var invalidValue = null;
  var keyName = null;
  var _iterator = _createForOfIteratorHelper(validateKey),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (failValueMap[key]) {
        keyName = key;
        invalidValue = failValueMap[key];
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var prefixInvalidValue = useMemo(function () {
    if (keyName == null) {
      return invalidValue;
    }
    if (keyName === VideoValidateKey.VIDEO_MEDIA_WIDTH) {
      return "\u5BBD".concat(invalidValue);
    }
    if (keyName === VideoValidateKey.VIDEO_MEDIA_HEIGHT) {
      return "\u9AD8".concat(invalidValue);
    }
  }, [invalidValue, keyName]);
  return React.createElement("span", {
    className: classnames(className, prefixInvalidValue ? "".concat(className, "-error") : '')
  }, prefixInvalidValue || value);
};
export var VideoSpecDetail = function VideoSpecDetail(props) {
  var failValue = props.failValue,
    children = props.children,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'bottom' : _props$placement,
    link = props.link,
    style = props.style;
  var cls = usePrefixCls('material-library-single-video-upload-fail-detail');
  var failValueMap = useMemo(function () {
    if (failValue == null) {
      return undefined;
    }
    return failValue.reduce(function (res, curr) {
      res[curr.item_key] = curr.item_value;
      return res;
    }, {});
  }, [failValue]);
  var content = React.createElement("div", {
    className: cls,
    style: style
  }, React.createElement("ul", null, VALIDATE_LIST.map(function (item) {
    return React.createElement("li", {
      className: "".concat(cls, "-list-item"),
      key: item.value
    }, React.createElement("span", {
      className: "".concat(cls, "-list-item-label")
    }, item.label), React.createElement("span", {
      className: "".concat(cls, "-list-item-value")
    }, item.value), failValueMap && React.createElement(VideoFailDetailItem, {
      className: "".concat(cls, "-list-item-invalid-value"),
      validateKey: item.key,
      failValueMap: failValueMap,
      value: item.value
    }));
  })), React.createElement("p", {
    className: "".concat(cls, "-desc")
  }, "* \u7EA2\u8272\u4E3A\u4E0D\u5408\u683C\u9879\uFF0C\u8BF7\u53C2\u8003", React.createElement("a", {
    href: link,
    target: "_blank"
  }, "\u300A\u89C6\u9891\u68C0\u6D4B\u53CA\u538B\u7F29\u65B9\u6CD5\u300B")));
  return React.createElement(Popover, {
    getPopper: function getPopper() {
      return content;
    },
    arrow: true,
    trigger: "hover",
    placement: placement
  }, children);
};
export var SingleVideoUpload = function SingleVideoUpload(props) {
  var onValueChange = props.onValueChange,
    value = props.value,
    compressDocLink = props.compressDocLink,
    onChange = props.onChange,
    panelProps = _objectWithoutProperties(props, _excluded);
  var cls = usePrefixCls('material-library-single-video-upload');
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    uploadValue = _useState2[0],
    setUploadValue = _useState2[1];
  var materialValue = useMemo(function () {
    return uploadValue ? [uploadValue] : [];
  }, [uploadValue]);
  useEffect(function () {
    if (value) {
      var item = {
        status: VideoUploadStatus.SUCCESS,
        value: _objectSpread(_objectSpread({}, value), {}, {
          transcode_status: TransferStatus.SUCCESS
        })
      };
      setUploadValue(item);
    }
    ;
  }, [value]);
  var materialChange = useRefCallback(function (val) {
    var _a, _b;
    setUploadValue(val[0]);
    if (((_a = val[0]) === null || _a === void 0 ? void 0 : _a.status) === VideoUploadStatus.SUCCESS) {
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(val[0].value);
      onChange === null || onChange === void 0 ? void 0 : onChange({
        type: VideoUploadChangeStatus.SUCCESS,
        value: val[0].value
      });
    } else if (((_b = val[0]) === null || _b === void 0 ? void 0 : _b.status) === VideoUploadStatus.FAIL) {
      onChange === null || onChange === void 0 ? void 0 : onChange({
        type: VideoUploadChangeStatus.FAIL
      });
    }
  });
  var removeHandler = useRefCallback(function () {
    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(null);
    setUploadValue();
    onChange === null || onChange === void 0 ? void 0 : onChange({
      type: VideoUploadChangeStatus.REMOVE
    });
  });
  var successText = (uploadValue === null || uploadValue === void 0 ? void 0 : uploadValue.status) === VideoUploadStatus.SUCCESS ? uploadValue.value.video_name : undefined;
  var videoItem = uploadValue && React.createElement("div", {
    className: "".concat(cls, "-video-item")
  }, React.createElement(UploadVideoStatusTag, {
    success: uploadValue.status === VideoUploadStatus.SUCCESS,
    successText: successText,
    onRemove: removeHandler
  }), uploadValue.status === VideoUploadStatus.FAIL && React.createElement(VideoSpecDetail, {
    link: compressDocLink,
    failValue: uploadValue.value
  }, React.createElement("span", {
    className: "".concat(cls, "-fail-detail-trigger")
  }, "\u89C6\u9891\u9519\u8BEF\u8BE6\u60C5")));
  var triggerNode = !uploadValue && React.createElement(Button, null, React.createElement(Upload, {
    size: 16,
    style: {
      marginRight: 4
    }
  }), "\u4E0A\u4F20");
  return React.createElement("div", {
    className: cls
  }, React.createElement(VideoPanel, _objectSpread(_objectSpread({}, panelProps), {}, {
    value: materialValue,
    onChange: materialChange
  }), triggerNode), videoItem);
};